<template>
    <div class="row">

        <div class="col-lg-8 col-lg-offset-2 col-xs-12 content">
            <CreditInfo />
        </div>

        <div class="col-lg-2 col-lg-offset-2 col-xs-12 block content">
            <UserMenu />
        </div>

        <div class="col-lg-6 col-xs-12 block content">
            <div class="setting">
                <h2>Billing & Invoice</h2>
                <UpdateCardInfo type='card'></UpdateCardInfo>
                <PreviousChargeTable />
            </div>
        </div>
    </div>
</template>

<script>

import CreditInfo from '@/components/CreditInfo.vue'
import UserMenu from '@/components/UserMenu.vue'
import PreviousChargeTable from '@/components/PreviousChargeTable.vue'
import UpdateCardInfo from '@/components/UpdateCardInfo.vue'

export default {
  name: 'billing',
  components: {
    CreditInfo,
    UserMenu,
    PreviousChargeTable,
    UpdateCardInfo
  }
}
</script>

<style lang="scss">

.icon {
    display: inline-block;
    vertical-align: middle;
}

.stripe-link {
    color: $color-1;
    font-weight: bold;
    text-decoration: none;
}

.stripe-info {
    margin-top: 20px;
    margin-bottom: 20px;
    text-align: left;
}

.info_content {
    text-align: left;
    margin-right: 10px;
}

.large {
    width: 98%;
}

.billing-form {
    margin: auto;
    width: 100%;
    text-align: left;
    justify-content: center;
}

.stripe-card {
  width: 98%;
  border: 1px solid $dark-1;
  background: $light;
  border-radius: 5px;
  padding: 15px;
  margin-top: 15px;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
}
.stripe-card.complete {
  border-color: green;
}

.content-left {
    float: left;
}

.ico {
    margin-right: 10px;
}

.setting {
    text-align: center;
    justify-content: center;
    margin: auto;
    margin-top: 50px;
    margin-left: 20px;
    height: 100%;
    padding-right: 10px;
}

.content {
    margin-top: 30px;
    margin-right: 1px;
    margin-bottom: 10px;
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
}

.credit {
    margin-top: 20px;
}

</style>
